import { PageViewEventLogger } from '@repo/tracking-service';
import { MainTitle } from '@repo/ui';
import { useState } from 'react';

import { CategoryFilter } from '@/components/help/faq/CategoryFilter';
import { FaqContent } from '@/components/help/faq/FaqContent';
import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { emptyStaticProps } from '@/lib/web/common-ssr';

const FaqPage = () => {
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.default, 'faq_cx_top-right');
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  return (
    <PageViewEventLogger pageName={'faq'}>
      <Layout leftIcon={{ icon: 'back', clickEvent: { name: 'faq_topnav_back' } }} rightTextButton={rightInquiryButton}>
        <div className={'page-padding'}>
          <MainTitle title={'비즈넵 환급의 진행 단계별\n자주 묻는 질문을 정리했어요'} size="medium" />
          <CategoryFilter selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
        </div>
        <FaqContent selectedCategory={selectedCategory} />
      </Layout>
    </PageViewEventLogger>
  );
};

export const getStaticProps = emptyStaticProps;

export default FaqPage;
